<template>
  <v-card
    class="add-metric d-flex align-center justify-center cursor-pointer"
    data-testid="add-metric-card"
    outlined
    :ripple="false"
    @click.stop="showMenu = !showMenu"
  >
    <v-menu v-model="showMenu" nudge-bottom="45" max-height="350">
      <template v-slot:activator="{ on }">
        <div
          v-on="on"
          class="menu-activator d-flex align-center justify-center"
          :class="smallMenu ? 'small-menu-activator' : 'large-menu-activator'"
        >
          <v-icon class="my-5" color="blue" size="20"
            >mdi-plus-circle-outline</v-icon
          >
        </div>
      </template>
      <v-list
        class="pa-0"
        dense
        data-testid="add-metric-options-list"
        flat
        v-for="(option, optionIndex) in Object.keys(optionsLists)"
        :key="optionIndex"
      >
        <v-subheader
          v-if="$constants.metricsType[option]"
          class="overline blue-grey--text text--darken-1 mx-4 py-3 pl-0 subheader"
          >{{ $t(`common.${$constants.metricsType[option]}`) }}
        </v-subheader>
        <v-list-item-group color="primary">
          <v-list-item
            v-for="(metric, metricIndex) in optionsLists[option]"
            :data-testid="`add-metric-option-${metric.id}`"
            :key="metricIndex"
            @click="handleSelectMetric(metric)"
          >
            <span class="font-size-13 blue-grey--text text--darken-3">
              {{ $t(`impacts.${metric.name}`) }}
            </span>
            <span
              v-if="
                metric.units.length &&
                  isImpact &&
                  getMagnitudeNames(metric.units)
              "
              class="caption blue-grey--text"
            >
              - {{ getMagnitudeNames(metric.units) }}
            </span>
          </v-list-item>
        </v-list-item-group>
      </v-list>
    </v-menu>
  </v-card>
</template>
<script>
import _ from 'lodash'

const DEFAULT_FREQUENCY = 'one_time'

export default {
  name: 'AddMetric',

  props: {
    optionsLists: { type: Object, default: () => {} },
    smallMenu: Boolean,
    isImpact: Boolean,
  },

  data() {
    return {
      showMenu: false,
    }
  },

  methods: {
    getMagnitudeNames(units) {
      const magnitudeNames = []
      units.map(unit =>
        unit.magnitude
          ? magnitudeNames.push(this.$t(`magnitudes.${unit.magnitude}`))
          : null
      )
      return _.uniq(_.concat(magnitudeNames)).join(', ')
    },

    handleSelectMetric(metric) {
      const uniqueUnit = metric?.units?.length === 1
      const isNumberMetric = metric?.units?.length === 0
      const defaultUnitForMultipleOptions = isNumberMetric ? '' : null
      const metricAdded = {
        ...metric,
        type: metric.id,
        value: null,
        frequency: DEFAULT_FREQUENCY,
        unit: uniqueUnit ? metric.units[0].name : defaultUnitForMultipleOptions,
      }
      this.$emit('select', metricAdded)
    },
  },
}
</script>

<style lang="scss" scoped>
.add-metric {
  &::before {
    background-color: transparent;
  }
  &:hover {
    border: 1px solid $color-blue-grey-lighten1 !important;
    transition: 0.2s ease;
  }
}

.small-menu-activator {
  width: 200px;
}
.large-menu-activator {
  width: 350px;
}

.subheader {
  border-bottom: 1px solid;
  border-bottom-color: $color-blue-grey-lighten1;
}
</style>
